import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

// ── Icons ─────────────────────────────────────────────────────────────────────

const IconCheck = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const IconPhone = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/>
  </svg>
);

const IconFlask = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9 3h6l1 9H8L9 3z"/>
    <path d="M6.8 21a6 6 0 0 0 10.4 0H6.8z"/>
    <line x1="12" y1="3" x2="12" y2="12"/>
  </svg>
);

const IconShield = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const IconWrench = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
  </svg>
);

const IconCalendar = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const IconLightbulb = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="9" y1="18" x2="15" y2="18"/>
    <line x1="10" y1="22" x2="14" y2="22"/>
    <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>
  </svg>
);

// ── Service data ──────────────────────────────────────────────────────────────

interface ServiceCard {
  id: string;
  icon: React.ReactNode;
  title: string;
  tagline: string;
  image: string;
  imageAlt: string;
  accent: string;
  items: string[];
}

const serviceCards: ServiceCard[] = [
  {
    id: 'tecnicos',
    icon: <IconPhone />,
    title: 'Servicios Técnicos Profesionales',
    tagline: 'Personal altamente capacitado que brinda servicio de alta calidad.',
    image: '/images/svc-technical.jpg',
    imageAlt: 'Técnico especializado brindando servicio en sitio',
    accent: '#38BDF8',
    items: [
      'Asesoría telefónica para equipos de pesaje',
      'Departamento especializado en automatización',
      'Optimización de equipos en sitio',
    ],
  },
  {
    id: 'prueba',
    icon: <IconFlask />,
    title: 'Equipo de Prueba',
    tagline: 'Herramientas especializadas con certificados de calibración vigentes.',
    image: '/images/svc-test-equipment.jpg',
    imageAlt: 'Equipo de prueba y diagnóstico para básculas industriales',
    accent: '#34D399',
    items: [
      'Herramientas con certificado de calibración',
      'Pruebas para diagnóstico rápido',
      'Resolución eficaz de problemas',
    ],
  },
  {
    id: 'calibracion',
    icon: <IconShield />,
    title: 'Calibración y Verificación',
    tagline: 'Servicios de calibración para básculas electrónicas y de alta capacidad.',
    image: '/images/svc-calibration.jpg',
    imageAlt: 'Laboratorio de calibración metrológica acreditado ante la EMA',
    accent: '#F59E0B',
    items: [
      'Laboratorio acreditado por EMA (M70)',
      'Calibración de instrumentos de pesaje',
      'Verificación por Unidad Acreditada',
    ],
  },
  {
    id: 'correctivo',
    icon: <IconWrench />,
    title: 'Mantenimiento Correctivo',
    tagline: 'Reparación especializada de equipos de las marcas que representamos.',
    
    image: '/images/svc-preventive.jpg',
    imageAlt: 'Técnico realizando reparación de equipo de pesaje industrial',
    accent: '#818CF8',
    items: [
      'Reparación de Avery Weigh-Tronix',
      'Reparación de Dillon',
      'Reparación de Rice Lake',
      'Garantía de funcionamiento correcto',
    ],
  },
  {
    id: 'preventivo',
    icon: <IconCalendar />,
    title: 'Mantenimiento Preventivo',
    tagline: 'Programas personalizables para mantener sus equipos en óptimas condiciones.',
    image: '/images/abc-joel.jpg',
    imageAlt: 'Mantenimiento preventivo en línea de producción industrial',
    accent: '#86EFAC',
    items: [
      'Contratos mensuales, trimestrales y semestrales',
      'Mantenimiento programado en sitio',
      'Prevención proactiva de fallas',
    ],
  },
  {
    id: 'consultoria',
    icon: <IconLightbulb />,
    title: 'Consultoría Especializada',
    tagline: 'Asesoría experta para optimizar sus procesos de pesaje e integración.',
    image: '/images/svc-consulting.jpg',
    imageAlt: 'Consultoría técnica especializada en soluciones de pesaje',
    accent: '#FCA5A5',
    items: [
      'Análisis de necesidades del proceso',
      'Recomendaciones técnicas a medida',
      'Optimización de procesos productivos',
      'Soporte continuo post-instalación',
    ],
  },
];

// ── Page ──────────────────────────────────────────────────────────────────────

const Services: React.FC = () => {
  return (
    <div className="svc-page">

      {/* ── Hero ── */}
      <section className="svc-hero">
        <div className="container svc-hero-content">
          <span className="svc-hero-overline">Soporte Especializado</span>
          <h1>Servicios Profesionales<br />de Pesaje</h1>
          <p>
            Técnicos certificados, laboratorio acreditado EMA y cobertura nacional
            para mantener sus equipos operando al máximo rendimiento.
          </p>
        </div>
      </section>

      {/* ── Service rows ── */}
      <section className="svc-services">

        <div className="svc-services-intro">
          <span className="svc-label">Nuestros Servicios</span>
          <h2 className="svc-section-title">Desde la asesoría hasta el mantenimiento</h2>
          <p className="svc-section-sub">
            Le acompañamos en cada etapa del ciclo de vida de sus equipos, con
            técnicos propios y certificaciones vigentes en toda la República.
          </p>
        </div>

        {serviceCards.map((svc, i) => {
          const isReverse = i % 2 !== 0;
          return (
            <div
              key={svc.id}
              className={`svc-row-stripe${isReverse ? ' svc-row-stripe--alt' : ''}`}
            >
              <div className={`svc-row${isReverse ? ' svc-row--reverse' : ''}`}>

                {/* Photo panel */}
                <div className="svc-row-photo" role="img" aria-label={svc.imageAlt}>
                  <img src={svc.image} alt="" loading="lazy" />
                  <div className="svc-row-photo-vignette" aria-hidden="true" />
                </div>

                {/* Content panel */}
                <div className="svc-row-content">
                  <h3 className="svc-row-title">{svc.title}</h3>
                  <p className="svc-row-tagline">{svc.tagline}</p>
                  <ul className="svc-row-items">
                    {svc.items.map((item) => (
                      <li key={item}>
                        <span className="svc-row-check" aria-hidden="true">
                          <IconCheck />
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>
          );
        })}
      </section>

      {/* ── Stats ── */}
      <section className="svc-stats">
        <div className="svc-stats-grid">
          <div className="svc-stat">
            <span className="svc-stat-num">EMA M70</span>
            <span className="svc-stat-label">Laboratorio acreditado</span>
          </div>
          <div className="svc-stat">
            <span className="svc-stat-num">M1 / M2 / M3</span>
            <span className="svc-stat-label">Calidad Pesas Patron</span>
          </div>
          <div className="svc-stat">
            <span className="svc-stat-num">4</span>
            <span className="svc-stat-label">Ciudades con técnicos propios</span>
          </div>
          <div className="svc-stat">
            <span className="svc-stat-num">3</span>
            <span className="svc-stat-label">Marcas con soporte certificado</span>
          </div>
        </div>
      </section>

      {/* ── Why us ── */}
      <section className="svc-why">
        <div className="container">
          <div className="svc-why-header">
            <span className="svc-label">Nuestra Diferencia</span>
            <h2 className="svc-section-title">¿Por qué elegir nuestro servicio?</h2>
            <p className="svc-section-sub">
              Respaldamos cada equipo con técnicos propios, certificaciones vigentes
              y el conocimiento de más de tres décadas en el sector.
            </p>
          </div>

          <div className="svc-why-grid">

            <div className="svc-why-card">
              <div className="svc-why-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  <polyline points="9 12 11 14 15 10"/>
                </svg>
              </div>
              <div className="svc-why-body">
                <h3>Laboratorio acreditado EMA</h3>
                <p>Calibración y verificación metrológica con trazabilidad a patrones nacionales e internacionales (M70).</p>
              </div>
            </div>

            <div className="svc-why-card">
              <div className="svc-why-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div className="svc-why-body">
                <h3>Técnicos certificados en sitio</h3>
                <p>Personal con formación directa de los fabricantes para diagnóstico y reparación autorizada de cada marca.</p>
              </div>
            </div>

            <div className="svc-why-card">
              <div className="svc-why-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
                  <line x1="9" y1="3" x2="9" y2="18"/>
                  <line x1="15" y1="6" x2="15" y2="21"/>
                </svg>
              </div>
              <div className="svc-why-body">
                <h3>Cobertura nacional</h3>
                <p>Técnicos propios en Guadalajara, CDMX, Monterrey y San Luis Potosí para atención en sitio sin demoras.</p>
              </div>
            </div>

            <div className="svc-why-card">
              <div className="svc-why-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div className="svc-why-body">
                <h3>Respuesta rápida garantizada</h3>
                <p>Contratos de mantenimiento preventivo y correctivo con tiempos de respuesta definidos para minimizar paros de producción.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="svc-cta">
        <div className="container">
          <h2>¿Necesita servicio o mantenimiento?</h2>
          <p>
            Cuéntenos sobre su equipo y nuestros técnicos le darán la atención
            que su proceso necesita, donde usted se encuentre.
          </p>
          <div className="svc-cta-actions">
            <Link to="/contacto" className="btn-primary">Solicitar Servicio</Link>
            <a href="tel:+523336349050" className="btn-outline">Llamar: (33) 3634-9050</a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Services;
